import React, { useEffect, useState } from "react";
import Navbar from "../../../../posnavbar/Navbar";
import "./MenuCategory.css";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { BootstrapInput } from "../../../../posnavbar/components/addCustomer/components/bootStrapInput";
import { createMenuCategory } from "../../../../../../config/Services";

export const CreateCategory = () => {
  const [categoryForm, setCategoryForm] = useState({
    categoryName: "",
    categoryDescription: "",
  });

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategoryForm({ ...categoryForm, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      sourceId: orgId,
      sourceLocationId: locId,
      categoryName: categoryForm.categoryName,
      categoryDescription: categoryForm.categoryDescription,
      categoryImage: "",
    };
    createMenuCategory(payload)
      .then((resp) => {
        console.log("Line 33", resp);
      })
      .catch((err) => {
        console.log("Line 36", err);
      });
  };

  return (
    <Navbar>
      <Box py={8} sx={{ width: "100%" }}>
        <Box className="createCategoryContainer">
          <p className="createCategoryHeading">Setup Your Categories:</p>
          <form onSubmit={handleSubmit}>
            <Box className="createCategoryForm">
              <Grid container spacing={2} mb={2}>
                <Grid item xs={12} md={4.5}>
                  <label>Enter Level 1/Category Name</label>
                  <br />
                  <BootstrapInput
                    placeholder="Enter Category Name"
                    id="bootstrap-input"
                    autoFocus
                    type="text"
                    className="categoryInput"
                    name="categoryName"
                    value={categoryForm.categoryName}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4.5}>
                  <label>Description</label>
                  <br />
                  <BootstrapInput
                    placeholder="Enter Description"
                    id="bootstrap-input"
                    autoFocus
                    type="text"
                    className="categoryInput"
                    name="categoryDescription"
                    value={categoryForm.categoryDescription}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label>Image</label>
                  <br />
                  <input type="text" placeholder="Upload Image" className="categoryInput" />
                </Grid>
              </Grid>
              {/* <Grid container spacing={2}>
                <Grid item xs={12} md={4.5}>
                  <label>Enter Level 2/Category Name</label>
                  <br />
                  <input type="text" placeholder="Enter Category Name" className="categoryInput" />
                </Grid>
                <Grid item xs={12} md={4.5}>
                  <label>Description</label>
                  <br />
                  <input type="text" placeholder="Enter Description" className="categoryInput" />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label>Image</label>
                  <br />
                  <input type="text" placeholder="Upload Image" className="categoryInput" />
                </Grid>
              </Grid> */}
              <Box className="createCategorySaveButton">
                <button type="submit">Save Item</button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    </Navbar>
  );
};
